module.exports = __webpack_public_path__ + "static/media/promotion_03.e78cb392.jpg";